import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, CardDeck, Col, Container, Row } from "react-bootstrap";
import swal from "sweetalert";
import "./Services.css";

const Services = () => {
  const [servicesList, setServicesList] = useState([]);
  useEffect(() => {
    axios
      .get("https://mysterious-sierra-48850.herokuapp.com/get-services")
      .then((data) => setServicesList(data.data))
      .catch((error) => {
        console.log(error.response);
        swal(
          `${error.response?.data}`,
          `${error.response?.statusText}`,
          "error"
        );
      });
  });

  const addCartHandler = async (service) => {
    const token = await JSON.parse(localStorage.getItem("user"));
    const { _id, name, price, description, image } = service;
    const cartItem = { name, price, description };

    axios
      .post(
        "https://mysterious-sierra-48850.herokuapp.com/add-to-cart",
        { serviceId: _id },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + token.token,
          },
        }
      )
      .then((data) => {
        console.log(data.data);
        if (data?.data?.success) {
          swal("Good Job!", `${data?.data?.message}`, "success");
        }
      })
      .catch((err) => {
        console.log(err.response);
        swal("Something Went Wrong", ``, "error");
      });
  };

  return (
    <Container>
      <div className="text-center">
        <h2 className="brand_text">Became a Member Today</h2>
        <p>Choose from our most popular membership options below</p>
      </div>
      <div className="service_card_container">
        {servicesList.map((service, index) => {
          return (
            <div className="service_card">
              <div className="service_card_box">
                <div className="service_card_box_image">
                  <img
                    src={`data:image/png;base64,${service?.image?.data}`}
                    alt="gym people"
                    className="img-fluid"
                  />
                </div>
                <div className="service_card_box_content">
                  <h2>{index + 1}</h2>
                  <h3>{service.name}</h3>
                  <p>{service.description}</p>
                  <h5 className="mb-0 pb-0">&#2547;{service?.price}</h5>
                  <button
                    className="mt-2"
                    onClick={() => addCartHandler(service)}
                  >
                    Join Now
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default Services;